import { render, staticRenderFns } from "./sku-list-dialog.vue?vue&type=template&id=5a74016b&scoped=true"
import script from "./sku-list-dialog.vue?vue&type=script&lang=ts"
export * from "./sku-list-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a74016b",
  null
  
)

export default component.exports